<h1 class="accessibility-only">Badges</h1>
<!--Banner-->
<div class="d-block">
  <fgb-banner [title]="'home.page.challenges' | translate"></fgb-banner>
</div>

<fgb-badges-nav></fgb-badges-nav>
<fgbcl-scorecard-list-view [icon]="'chevron_right'" [phaseThree]="true" [showPlaceholder]="true" [ngClass]="isCorporate ? 'corporate' : 'membership'"></fgbcl-scorecard-list-view>
